<!-- uebungen-library-absolve-uebung-modal.vue -->
<template>
  <div class="uebungen-library__modal flex flex-col fixed top-0 left-0 w-screen h-screen z-[1000]">
    <div
      class="uebungen-library__modal-header relative flex flex-row justify-center items-center px-20 bg-primary-900 text-white transition-all delay-75">
      <div class="flex flex-row justify-center items-center">
      <button @click="closeModal"
        class="flex flex-row items-center py-3 px-8 hover:text-secondary_color transition-all">
        <hermeneus-icon name="hi-uebungen-new" color="current" height="48" width="48" class="mr-2"></hermeneus-icon>
        <span class="text-xl font-light md-minus:hidden">Übungsbibliothek</span>
      </button>
      <i class="fas fa-angle-right mx-5"></i>
      <button
        @click="loadComponentInModal('uebungen-library-absolve-uebung', 'Übung absolvieren', 'hi-uebung-play')"
        :class="{ 'bg-primary-800': component_alias === 'uebungen-library-absolve-uebung', 'bg-primary-900': component_alias !== 'uebungen-library-absolve-uebung' }"
        class="flex flex-row items-center bg-primary-800 py-3 px-8 hover:text-secondary_color transition-all">
        <hermeneus-icon name="hi-uebung-play" color="current" height="48" width="48" class="mr-2 pt-2"></hermeneus-icon>
        <span class="text-xl font-light md-minus:hidden">Übung durchführen</span>
      </button>
      <!-- DATEN DER AKTUELLEN KOMPONENTE WERDEN HIER IM HEADER ANGEZEIGT -->
      <div v-if="component_alias && (component_alias !== 'uebungen-library-absolve-uebung')"
        class="flex flex-row items-center">
        <i class="fas fa-angle-right mx-5"></i>
        <button
          class="flex flex-row items-center py-3 px-8 bg-white text-primary-700 hover:text-secondary_color transition-all">
          <hermeneus-icon :name="component_icon" color="current" height="48" width="48" class="mr-2"></hermeneus-icon>
          <span class="text-xl md-minus:hidden">{{ component_title }}</span>
        </button>
      </div>
      </div>
      <button class="absolute right-8 top-1/2 transform -translate-y-1/2 text-primary-400 hover:text-white" @click="closeModal"><i class="text-3xl fas fa-times"></i></button>
    </div>
    <div class="uebungen-library__modal-content flex-grow overflow-auto">
      <transition name="slide" mode="out-in">
        <div v-if="isLoading" class="pt-32 flex justify-center items-center">
          <loading-comet class="text-primary-700"></loading-comet>
        </div>
        <component v-else-if="dynamicComponent" :is="dynamicComponent" :data="component_data" class="p-5 bg-white"></component>

      </transition>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../hermeneus.eventbus/eventbus.js";
import {haxiosAPIClient} from "@/haxios/haxios.js"
import LoadingComet from "@/loader/LoadingComet.vue";
export default {
  name: "uebungen-library-absolve-uebung-modal",
  props: {
    uebung: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isClosing: false,
      isLoading: false,
      component_alias: null,
      component_title: null,
      component_icon: null,
      component_data: null
    };
  },
  computed: {
    resolvedUebung() {
      return this.$resolveUebungFromRegistry(this.uebung.uebung_type);
    },
    dynamicComponent() {
      return this.component_alias || 'uebungen-library-absolve-uebung';
    }
  },
  methods: {
    closeModal() {
      this.isClosing = true;
      setTimeout(() => {
        this.$emit('close-absolve-uebung-modal');
        this.isClosing = false;
      }, 300);
    },
    /**
     * Liest aus der UebungenRegistry die Komponenteninformationen aus, die in der
     * config.json definiert sind.
     */
    getAbsolveComponent() {
      this.component_alias = this.$resolveUebungFromRegistry(this.uebung.uebung_type).components.absolve.alias;
      this.component_title = this.$resolveUebungFromRegistry(this.uebung.uebung_type).components.absolve.title;
      this.component_icon = this.$resolveUebungFromRegistry(this.uebung.uebung_type).appearance.icon ?? null;
      this.getAbsolveComponentData();
    },
    getAbsolveComponentData() {
      this.isLoading = true;
      haxiosAPIClient.get(`/uebungen/absolve/${this.uebung.id}`).then(response => {
        this.component_data = response.data.data;
        this.isLoading = false;
      });
    },
    loadComponentInModal(component_alias, component_title, component_icon, component_data) {
      this.component_alias = component_alias;
      this.component_title = component_title;
      this.component_icon = component_icon;
      this.component_data = component_data;
    },
    handleEscKey(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    },
    preventScroll() {
      document.body.style.overflow = 'hidden';
    },
    enableScroll() {
      document.body.style.overflow = '';
    }
  },
  mounted() {
    this.getAbsolveComponent();
    // Hintergrund-Scrolling deaktivieren
    this.preventScroll();
    
    // Event-Listener für ESC-Taste hinzufügen
    window.addEventListener('keydown', this.handleEscKey);
    
    // Event-Listener für das Laden von Komponenten im Modal
    EventBus.$on('uebungen-library__load-component-in-absolve-modal', ComponentData => {
      this.loadComponentInModal(ComponentData.component_alias, ComponentData.component_title, ComponentData.component_icon);
    });
  },
  beforeDestroy() {
    // Hintergrund-Scrolling wieder aktivieren
    this.enableScroll();
    
    // Event-Listener entfernen
    window.removeEventListener('keydown', this.handleEscKey);
    EventBus.$off('uebungen-library__load-component-in-absolve-modal');
  }
}
</script>

<style scoped>
.uebungen-library__modal {
  background-color: hsl(232deg 23% 13%); /* Dunkelblau wie der Create-Button */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease;
}

.uebungen-library__modal__backdrop {
  transition: opacity 0.3s ease;
}

.uebungen-library__modal__content {
  animation: slideIn 0.3s ease;
  max-height: 100vh;
}

.uebungen-library__modal__backdrop.closing {
  opacity: 0;
}

.uebungen-library__modal__content.closing {
  animation: slideOut 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(50px);
    opacity: 0;
  }
}

.uebungen-library__modal-header {
  opacity: 0;
  animation: fadeIn 0.5s ease-in-out forwards;
  animation-delay: 500ms;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-enter-to,
.slide-leave-from {
  transform: translateX(0);
  opacity: 1;
}

.uebungen-library__modal-content {
  flex-grow: 1;
  overflow: auto;
}
</style>
